import React, {Component} from 'react';

import {Switch, Route} from 'react-router-dom';
import MainContainer from '../modules/main-container';
import Login from '../modules/login';
import NotFound from '../modules/not-found';

class App extends Component {

    render() {
        return (
            <Switch>
                <Route path="/login-google" component={Login}/>
                <Route path="/" component={MainContainer}/>
                <Route component={NotFound}/>
            </Switch>
        );
    }
}

export default App;
